import { EntityActionFactory, EntityOp } from '@ngrx/data';

import { TipoSexoBiologico } from './entity-sexo-biologico.model';

const entityActionFactory = new EntityActionFactory();

export const entityTiposSexoBiologicoLoadRequest =
  entityActionFactory.create<TipoSexoBiologico>(
    'TipoSexoBiologico',
    EntityOp.QUERY_ALL
  );
